import { render, staticRenderFns } from "./LffPreFooter.vue?vue&type=template&id=0bbf1f82&scoped=true&"
import script from "./LffPreFooter.vue?vue&type=script&lang=js&"
export * from "./LffPreFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbf1f82",
  null
  
)

export default component.exports